module.exports = __webpack_public_path__ + "img/agent-task.418cdf76.svg";